import Vue from 'vue'
import * as TYPES from './types'

export default {
  [TYPES.SET_TASTINGS](state, tastings) {
    if (tastings && Array.isArray(tastings)) {
      Vue.set(state, 'tastings', tastings)
    }
  },
  [TYPES.SET_SECTIONS](state, { allIds, byId }) {
    Vue.set(state.section, 'allIds', allIds)
    Vue.set(state.section, 'byId', byId)
  },
  [TYPES.SET_TASTING_QUESTIONS](state, { allIds, byId }) {
    Vue.set(state.question, 'allIds', allIds)
    Vue.set(state.question, 'byId', byId)
  },
  [TYPES.SET_TASTING_TRANSITIONS](state, { allIds, byId }) {
    Vue.set(state.transition, 'allIds', allIds)
    Vue.set(state.transition, 'byId', byId)
  },
  [TYPES.SET_TASTING_ANSWER](state, { answerId, value }) {
    Vue.set(state.userResponses, answerId, value)
  },
  [TYPES.SET_TASTING_FIREBASE_ID](state, firebaseId) {
    Vue.set(state, 'firebaseId', firebaseId)
  },
  [TYPES.RESET_TASTING_FIREBASE_ID](state) {
    Vue.delete(state, 'firebaseId')
  }
}
